const emailAddress = "jamesriady1998@yahoo.com";

export const SendEmail = () => {
    var link = `mailto:${emailAddress}`
    window.location.href = link; 
    return false;
}